import {useCallback, useEffect, useLayoutEffect, useRef, useState} from "react";
import {useReducedMotion} from "framer-motion";

interface IParams {
    activePreleadId: number | undefined;
    currentPreleadIndex: number;
    isOpen: boolean;
}

export function useHomematchTinderDeckAnimation(params: IParams) {
    const {activePreleadId, currentPreleadIndex, isOpen} = params;

    const shouldReduceMotion = useReducedMotion();

    const activeIdRef = useRef<number | undefined>(undefined);
    const contentRef = useRef<HTMLDivElement>(null);
    const contentReadyRef = useRef(true);
    const isAdvancingRef = useRef(false);
    const lastDeckHeightRef = useRef<number | null>(null);
    const observerRef = useRef<ResizeObserver | null>(null);
    const prevIndexRef = useRef(currentPreleadIndex);

    const [frozenHeight, setFrozenHeight] = useState<number | null>(null);
    const [isAdvancing, setIsAdvancing] = useState(false);

    activeIdRef.current = activePreleadId;

    const captureDeckHeight = useCallback((height: number) => {
        if (isAdvancingRef.current) return;

        lastDeckHeightRef.current = height;
    }, []);

    const releaseAdvanceIfReady = useCallback(() => {
        if (!contentReadyRef.current) return;

        setIsAdvancing(false);
        setFrozenHeight(null);
    }, []);

    const handleCardReady = useCallback(
        (preleadId: number, ready: boolean) => {
            if (preleadId !== activeIdRef.current) return;

            contentReadyRef.current = ready;

            if (ready) releaseAdvanceIfReady();
        },
        [releaseAdvanceIfReady]
    );

    const setDeckNode = useCallback(
        (node: HTMLDivElement | null) => {
            observerRef.current?.disconnect();
            observerRef.current = null;

            if (!node || typeof ResizeObserver === "undefined") return;

            captureDeckHeight(node.offsetHeight);

            const observer = new ResizeObserver(() => captureDeckHeight(node.offsetHeight));

            observer.observe(node);
            observerRef.current = observer;
        },
        [captureDeckHeight]
    );

    useEffect(() => {
        isAdvancingRef.current = isAdvancing;
    }, [isAdvancing]);

    useLayoutEffect(() => {
        const hasAdvancedToNextCard = currentPreleadIndex > prevIndexRef.current;

        if (hasAdvancedToNextCard) {
            contentReadyRef.current = activePreleadId === undefined;
            setFrozenHeight(lastDeckHeightRef.current);
            setIsAdvancing(true);

            if (contentRef.current) contentRef.current.scrollTop = 0;
        }

        prevIndexRef.current = currentPreleadIndex;
    }, [activePreleadId, currentPreleadIndex]);

    useEffect(() => {
        if (isOpen) return;

        setIsAdvancing(false);
        setFrozenHeight(null);
        contentReadyRef.current = true;
        prevIndexRef.current = 0;
    }, [isOpen]);

    return {
        contentRef,
        frozenHeight,
        handleCardReady,
        isAdvancing,
        setDeckNode,
        shouldReduceMotion: Boolean(shouldReduceMotion)
    };
}
import {useCallback, useEffect, useLayoutEffect, useRef, useState} from "react";
import {useReducedMotion} from "framer-motion";

interface IParams {
    activePreleadId: number | undefined;
    currentPreleadIndex: number;
    isOpen: boolean;
}

export function useHomematchTinderDeckAnimation(params: IParams) {
    const {activePreleadId, currentPreleadIndex, isOpen} = params;

    const shouldReduceMotion = useReducedMotion();

    const activeIdRef = useRef<number | undefined>(undefined);
    const contentRef = useRef<HTMLDivElement>(null);
    const contentReadyRef = useRef(true);
    const isAdvancingRef = useRef(false);
    const lastDeckHeightRef = useRef<number | null>(null);
    const observerRef = useRef<ResizeObserver | null>(null);
    const prevIndexRef = useRef(currentPreleadIndex);

    const [frozenHeight, setFrozenHeight] = useState<number | null>(null);
    const [isAdvancing, setIsAdvancing] = useState(false);

    activeIdRef.current = activePreleadId;

    const captureDeckHeight = useCallback((height: number) => {
        if (isAdvancingRef.current) return;

        lastDeckHeightRef.current = height;
    }, []);

    const releaseAdvanceIfReady = useCallback(() => {
        if (!contentReadyRef.current) return;

        setIsAdvancing(false);
        setFrozenHeight(null);
    }, []);

    const handleCardReady = useCallback(
        (preleadId: number, ready: boolean) => {
            if (preleadId !== activeIdRef.current) return;

            contentReadyRef.current = ready;

            if (ready) releaseAdvanceIfReady();
        },
        [releaseAdvanceIfReady]
    );

    const setDeckNode = useCallback(
        (node: HTMLDivElement | null) => {
            observerRef.current?.disconnect();
            observerRef.current = null;

            if (!node || typeof ResizeObserver === "undefined") return;

            captureDeckHeight(node.offsetHeight);

            const observer = new ResizeObserver(() => captureDeckHeight(node.offsetHeight));

            observer.observe(node);
            observerRef.current = observer;
        },
        [captureDeckHeight]
    );

    useEffect(() => {
        isAdvancingRef.current = isAdvancing;
    }, [isAdvancing]);

    useLayoutEffect(() => {
        const hasAdvancedToNextCard = currentPreleadIndex > prevIndexRef.current;

        if (hasAdvancedToNextCard) {
            contentReadyRef.current = activePreleadId === undefined;
            setFrozenHeight(lastDeckHeightRef.current);
            setIsAdvancing(true);

            if (contentRef.current) contentRef.current.scrollTop = 0;
        }

        prevIndexRef.current = currentPreleadIndex;
    }, [activePreleadId, currentPreleadIndex]);

    useEffect(() => {
        if (isOpen) return;

        setIsAdvancing(false);
        setFrozenHeight(null);
        contentReadyRef.current = true;
        prevIndexRef.current = 0;
    }, [isOpen]);

    return {
        contentRef,
        frozenHeight,
        handleCardReady,
        isAdvancing,
        setDeckNode,
        shouldReduceMotion: Boolean(shouldReduceMotion)
    };
}
